import { singularityStore } from "@/store/store";
import { getClaimUrl } from "./connector";

export function getInstaWPTimeRemainingInSeconds(): number | null {
  const siteState = singularityStore.siteStatus.siteState;

  if (!siteState || 'error' in siteState) return null;
  if (!siteState.expiration) return null;

  const secondsRemaining = ((siteState.expiration * 1000) - Date.now()) / 1000;
  return secondsRemaining;
}

export function formatInstaWPTimeRemaining(seconds: number, includeSeconds: boolean): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (includeSeconds) {
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  } else {
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}`;
    }
    return `${minutes}m`;
  }
}

export function getSecondsTilSiteExpiration(): number | null {
  const siteState = singularityStore.siteStatus.siteState;

  if (!siteState || 'error' in siteState) return null;
  if (!siteState.expiration) return null;

  const secondsRemaining = ((siteState.expiration * 1000) - Date.now()) / 1000;
  return secondsRemaining;
}

export function handleClaimSite(): void {
  const claimUrl = getClaimUrl();
  if (claimUrl) {
    const returnTo = encodeURIComponent(window.location.href);
    const urlWithReturn = `${claimUrl}&return_to=${returnTo}`;
    window.location.href = urlWithReturn;
  }
}
